import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Fixed: Removed 'on'
import InputField from '../common/InputField'; // Import InputField component
import { Button } from '../common/Button'; // Import Button component
import { sendResetPasswordEmail } from '../../api/apiService'; // Import API function

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrors({});

        if (!email) {
            setErrors({ email: 'Email is required.' });
            setLoading(false);
            return;
        }

        try {
            const response = await sendResetPasswordEmail(email);
        
            if (response.error) {
                // Display the error message to the user
                setErrors({ general: response.message });
            } else {
                // Display the success message to the user
                setMessage(response.message);
            }
        } catch (error) {
            // Handle any unexpected errors
            setErrors({ general: 'An unexpected error occurred. Please try again later.' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100">
            <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center text-text">Forgot Password</h2>
                {errors.general && <p className="text-primary text-sm mb-4">{errors.general}</p>}
                {message && <p className="text-green-600 text-sm mb-4">{message}</p>}

                <InputField
                    label="Email"
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    required
                    error={errors.email}
                />

                <div className="flex justify-center">
                    <Button type="submit" disabled={loading} className="w-64">
                        {loading ? 'Sending...' : 'Send Reset Link'}
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default ForgotPassword;